/**
 * Created by pzf on 18/9/1.
 *
 */
import lang from 'lodash/lang';

export function shallowClone(obj) {
  return lang.clone(obj);
}

export function deepClone(obj) {
  return lang.cloneDeep(obj);
}
